export const SLIDE_PRELOAD_LIMIT = 5;

export const WRAPPER_HEIGHT = 320;
export const WRAPPER_HEIGHT_READONLY = 280;
export const TOOLBAR_HEIGHT = 30;

export const IMAGE_WRAPPER_HEIGHT = WRAPPER_HEIGHT - TOOLBAR_HEIGHT;
export const IMAGE_WRAPPER_HEIGHT_READONLY = WRAPPER_HEIGHT_READONLY - TOOLBAR_HEIGHT;
